import { combineReducers } from 'redux'
import EuropeReducer from './EuropeReducer'
import AsiaReducer from './AsiaReducer'
import AmericaReducer from './AmericaReducer'

export default combineReducers({
  europe: EuropeReducer,
  asia: AsiaReducer,
  america: AmericaReducer
})